import { useAuth } from '../auth/AuthAllapot.tsx';
import { Kartya } from '../ui/elemek.tsx';
import { type LeadSor } from './AdatokPanel.tsx';
import { hivasSzkript } from './hivasSzkript.ts';

/** Az értékesítő által felolvasható hívásszkript; mindig csukva indul. */
export default function HivasSzkript({ lead: l }: { lead: LeadSor }) {
  const { profil } = useAuth();
  if (l.statusz === 'nem_ellenorzott') return null;
  // Szakértői becslésnél vagy hiányzó sávnál szám nélküli szöveg (mint a savAdat a főkönyvben).
  const sav = !l.szakertoi_becsles && l.becsles_min !== null && l.becsles_max !== null ? { min: l.becsles_min, max: l.becsles_max } : null;
  const bekezdesek = hivasSzkript({
    irodaNev: l.iroda?.nev ?? 'iroda',
    ertekesitoNev: l.kollega?.nev ?? profil?.nev ?? null,
    hely: [l.terulet?.nev ?? l.iranyitoszam, [l.utca, l.hazszam].filter(Boolean).join(' ')].filter(Boolean).join(', '),
    sav,
  });
  return (
    <Kartya>
      <details className="min-w-0" data-testid="hivas-szkript">
        <summary className="cursor-pointer text-lg font-medium tracking-[-0.01em]">Hívásszkript</summary>
        <div className="mt-3 grid min-w-0 gap-3">
          {bekezdesek.map((b, i) => (
            <div key={i} className={`min-w-0 wrap-anywhere ${b.instrukcio ? 'text-[13px] text-szoveg-halk' : 'text-[15px] leading-relaxed'}`}>
              {b.cim && <p className="mb-0.5 text-[13px] font-semibold text-szoveg-halk">{b.cim}</p>}
              <p>{b.reszek.map((x, j) => (x.felkover ? <strong key={j}>{x.szoveg}</strong> : <span key={j}>{x.szoveg}</span>))}</p>
            </div>
          ))}
        </div>
      </details>
    </Kartya>
  );
}
